import * as React from "react"
import { SelectSeeker } from "@ui-seeker/core";

import { NOTIFICATIONS_TYPE } from "../../../@constants";
import { repricingActionRuleSelected, repricingFormCheckerData } from "../../../@signals";


const OPTIONS = [
	{ label: 'Repricing', value: NOTIFICATIONS_TYPE.REPRICING },
	{ label: 'Notification', value: NOTIFICATIONS_TYPE.NOTIFICATION },
	{ label: 'Repricing & Notification', value: NOTIFICATIONS_TYPE.REPRICING_NOTIF },
]

export default function RepricingFormActionRuleSelect() {
	return <SelectSeeker
		options={OPTIONS}
		value={repricingActionRuleSelected.value}
		onChange={e => {
			repricingFormCheckerData.value = {}
			repricingActionRuleSelected.value = e.target.value
		}}
	/>
}